import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export var checkLeaveEligibilityRes;
export const checkLeaveEligibilityTodo = createAsyncThunk('checkLeaveEligibility', async (data) => {
    let user_id = JSON.parse(localStorage.getItem('user_data'))
    try {
        const res = await axios({

            method: "post",
            url: process.env.REACT_APP_API_URL + 'hr/check_leave_eligibility',
            data: {
                "user_id": user_id.vemp_code,
                "user_role": user_id.vrole_name,
                "device_token": user_id.vdevice_token,
                "yearly_scheme_code": user_id.yearly_scheme_code,
                "dfrom_date": data?.date,
            },
            headers: { "Content-Type": "application/json", "Authorization": 'Bearer ' + user_id.access_token }
        })
        return checkLeaveEligibilityRes = res.data
    } catch (error) {
        return checkLeaveEligibilityRes = error.response.data
    }
})